module.exports = __webpack_public_path__ + "img/logo-sesi-light.4b6a75d4.svg";